import { Typography } from '@mui/material';
import React from 'react';

import { ListItem, IdAndName } from '../../shared/types';
import { getDeskLink } from '../../utils/link.utils';
import { sortArray } from '../../utils/sorting.utils';
import LinkList, { ListItemOrientation, ListItemType } from './LinkList';

export interface DesksSectionProps {
    deskList?: IdAndName[];
}

export const DesksSection: React.FC<DesksSectionProps> = (props) => {
    if (!props.deskList?.length) return null;

    const dataToShow: ListItem[] = sortArray(props.deskList, 'name').map(
        (art) => ({
            id: art._id,
            name: art.name,
            url: getDeskLink(art._id),
        })
    );

    return (
        <div>
            <Typography sx={{ mb: 2 }} variant="h5">
                Desks
            </Typography>
            <div id={'desks-section'}>
                <LinkList
                    disableSort
                    items={dataToShow}
                    orientation={ListItemOrientation.Vertical}
                    displayType={ListItemType.Link}
                    isSpacedVerticalLinks={true}
                />
            </div>
        </div>
    );
};

export default DesksSection;
